import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation PdpSharedFollowDealerMutation($input: FavoriteSellerInput!, $userId: String!) {
        favoriteSeller(input: $input) {
            seller {
                id
                favoritesByUser(userIds: $userId) {
                    serviceId
                }
            }
        }
    }
`;

function commit(environment, args) {
    const { userId, sellerId, sellerPk, favoriteId, onCompleted, onError } = args;

    const variables = {
        input: { userId, sellerPk, favoriteId },
        userId,
    };

    commitMutation(environment, {
        mutation,
        variables,
        optimisticResponse: {
            favoriteSeller: {
                seller: {
                    id: sellerId,
                },
            },
        },
        onCompleted,
        onError,
    });
}

export const PdpSharedFollowDealer = {
    commit,
};
